//REQUIREMENTS ON PAGE USING DYNAMIC ALERTS
//1. Inculde ~/bundles/handlebars
//2. Add DIV on page where the Alerts should display
//    <div id="dynamicAlerts"></div>
//3. Call one the functions below to display Alerts by location
//4. Add Alert Template 
//    <script id="alert-entry" type="text/x-handlebars-template">
//        <div class="usa-alert usajobs-alert usajobs-alert--info usajobs-alert--info" id="{{alert_id}}" role="alert" data-object="alert">
//            <div class="usajobs-alert__figure">
//                <div class="usajobs-alert__icon">
//                </div>
//            </div>
//           <div class="usajobs-alert__body">
//                <h3 class="usa-alert-heading">
//                    {{ alert_title }}
//                </h3>
//                <p class="usa-alert-text">
//                    {{{alert_description}}}
//                                </p>
//                <div class="usajobs-alert__footer">
//                </div>
//            </div>
//            <button class="usajobs-alert__close" data-behavior="alert.close">
//                <span class="usajobs-assistive-text">Close</span>
//            </button>
//        </div>
//    </script>
import * as alertEntryTemplate from "./Templates/alert_entry.handlebars";
export function GetAlerts(alertIDName, location) {
    GetAlertsWithHandlebars(alertIDName, location, Handlebars);
}

export function GetAlertsWithHandlebars(alertIDName, location) {
    $.get("/Notification/GetAlertsByLocation/" + location, function (data) {
        DisplayAlerts(data, alertIDName);
    });
}

export function DisplayAlerts(alerts, alertIDName) {
    $.each(alerts, function (i, key) {
        var alertID = alertIDName + key.AlertID,
            dismissedAlerts = Basil.sessionStorage.get("dismissedAlerts");

        if (!(alertID in dismissedAlerts)) {
            var alertData = { alert_title: key.Title, alert_description: key.Description, alert_id: alertID };

            $('#dynamicAlerts').append(alertEntryTemplate(alertData));
        }
    });

    var $alert = $('[data-object="alert"]');

    $alert.on('click', '[data-behavior]', function (event) {
        var $el = $(this),
            $object = $el.closest('[data-object="alert"]'),
            $target = $object.find('#' + $el.attr('aria-controls')),
            state = $target.attr('aria-hidden'),
            behavior = $el.attr('data-behavior');

        event.preventDefault();
        $el.blur(); // Removes focus

        // Each behavior attached to the element should be triggered
        $.each(behavior.split(' '), function (idx, action) {
            if (action.match(/^alert/)) {
                $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
            }
        });
    });

    $alert.on('alert.close', function (event, opts) {
        opts.object.attr('data-state', 'is-closed');
        opts.object.attr('aria-hidden', 'true');
        var dismissedAlerts = Basil.sessionStorage.get("dismissedAlerts");
        dismissedAlerts[opts.object.attr('id')] = new Date();
        Basil.sessionStorage.set("dismissedAlerts", dismissedAlerts);
    });

}

